const jsonToProps = ({ image, title, subtitles, ...props }) => ({
  ...props,
  creditOffer: {
    image,
    title,
    subtitles,
  },
});

export default jsonToProps;
